// partners
import leda_health from "../assets/images/clients/leda-health.svg";
import tm from "../assets/images/clients/tech-mahindra.svg";
import e_transact from "../assets/images/clients/etranzact.svg";
import bc from "../assets/images/clients/bain-company.svg";
import lsef from "../assets/images/clients/lsetf.svg";
import mavenir from "../assets/images/clients/mavenir.svg";
import mtn from "../assets/images/clients/mtn.svg";
import cadg from "../assets/images/clients/cadg.svg";
import charles_araujo from "../assets/images/clients/charles-araujo.svg";
import gsm_systems from "../assets/images/clients/gsmsystems.svg";
import veriteks from "../assets/images/clients/veritek.svg";
import airtel from "../assets/images/clients/airtel.svg";
import cri2 from "../assets/images/clients/cri.svg";
import laspark from "../assets/images/clients/laspark.svg";
import chi from "../assets/images/clients/chi.svg";
import ikejaElectric from "../assets/images/clients/ikeja-electric.png";
import scoa from "../assets/images/clients/scoa.png";

// services
import service_one from "../assets/images/sections/service_one.jpg";
import service_two from "../assets/images/sections/service_two.jpg";
import service_three from "../assets/images/sections/service_three.jpg";

// icons
import icon_white from "../assets/images/icons/crest_white.png";
import down from "../assets/images/icons/down.svg";
import checkmark from "../assets/images/icons/checkmark.svg";
import star from "../assets/images/icons/star.svg";
import proven from "../assets/images/icons/proven.svg";
import protect from "../assets/images/icons/protect.svg";
import gives from "../assets/images/icons/gives.svg";
import creates from "../assets/images/icons/creates.svg";
import left from "../assets/images/icons/left.svg";
import right from "../assets/images/icons/right.svg";
import target from "../assets/images/icons/target.svg";
import idea from "../assets/images/icons/idea.svg";

// sections
import hunters from "../assets/images/sections/hunters.jpg";
import seekers from "../assets/images/sections/seekers.png";
import hero from "../assets/images/sections/hero.png";

// industries
import tech from "../assets/images/industries/tech.svg";
import finance from "../assets/images/industries/finance.svg";
import education from "../assets/images/industries/education.svg";
import hospitality from "../assets/images/industries/hospitality.svg";
import construction from "../assets/images/industries/construction.svg";
import pub from "../assets/images/industries/public.svg";
import energy from "../assets/images/industries/energy.svg";
import maritime from "../assets/images/industries/maritime.svg";
import manufacturing from "../assets/images/industries/manufacturing.svg";

// team
import teams_bg from "../assets/images/team/meet-team.png";

// testimonials
import bainCompany from "../assets/images/clients/bain-company.png";
import mw from "../assets/images/clients/m&w.png";
import gsm from "../assets/images/clients/gsm.png";
import cri from "../assets/images/clients/cri.png";
import etranzact from "../assets/images/clients/etranzact.png";
import elizabeth from "../assets/images/clients/elizabeth-a.png";
import deborah from "../assets/images/clients/deborah-a.png";
import chinyere from "../assets/images/clients/chinyere-l.png";
import ACCL from "../assets/images/clients/ACCL.png";
import maison from "../assets/images/clients/Maison_Eric_Kayser.png";
import proforce from "../assets/images/clients/proforce.png";
import sunmetal from "../assets/images/clients/sunmetals.png";

// bespoke
import discovery from "../assets/images/icons/discovery.svg";
import kickoff from "../assets/images/icons/kickoff.svg";
import precise from "../assets/images/icons/precise.svg";
import final from "../assets/images/icons/final.svg";
import check from "../assets/images/icons/check.svg";
import arrow from "../assets/images/icons/arrow.svg";

// leadership
import ememUsen from "../assets/images/team/emem-usen.jpg";
import atsuEmmanuel from "../assets/images/team/atsu-emmanuel.png";
// import susan from '../assets/images/team/susan-iliyan.jpg';
// import jairaj from "../assets/images/team/jairaj-suvarna.jpg";

// team members
import avatar from "../assets/images/team/avatar-photo.jpeg";
import contingency from "../assets/images/clients/contingency.png";

import twitter from "../assets/images/icons/twitter.svg";
import error404 from "../assets/images/icons/404.svg";
// import abdulrasheedOladipo from "../assets/images/team/oladipo-abdulrasheed.png";
import christianMonte from "../assets/images/team/christian-monte.jpg";
import ebenezerNdukwe from "../assets/images/team/ebenezer-ndukwe.jpg";
import gabrielIkponmwosa from "../assets/images/team/ikponmwosa-gabriel.png";
import khalidMisbaudeen from "../assets/images/team/misbaudeen-khalid.png";
// import toheebRaheem from "../assets/images/team/toheeb-raheem.jpg";
// import sanniAdesanya from "../assets/images/team/sanni-adesanya.jpg";
import danielIleso from "../assets/images/team/ileso-daniel.png";
import tobiAkintelure from "../assets/images/team/akintelure-tobiloba.png";
import anabelInah from "../assets/images/team/inah-anabel.png";
import oyatogunEniola from "../assets/images/team/oyatogun-eniola.png";
// import chiamakaEze from "../assets/images/team/chiamaka-eze.jpeg";
// import sandraOghogho from "../assets/images/team/sandra-oghogho.jpeg";

// give/charity
import giveSlider from "../assets/images/background/give-slider.jpg";
import giveSlider2 from "../assets/images/background/give-slider2.jpg";
import giveSlider3 from "../assets/images/background/give-slider3.jpg";
import giveSlider4 from "../assets/images/background/give-slider4.jpeg";
import world from "../assets/images/background/world.jpg";
import generalImpact from "../assets/images/background/general-impact.jpg";
import kinabuti from "../assets/images/background/kinabuti.jpg";
import kinabuti2 from "../assets/images/background/kinabuti2.jpg";
import kids from "../assets/images/background/kids.png";
import slider1 from "../assets/images/background/slider1.jpg";
import help from "../assets/images/background/help.png";
import charity from "../assets/images/background/charity.jpeg";
import charity2 from "../assets/images/background/charity2.jpeg";

const now = new Date();
const currentYear = now.getFullYear();
const currentMonthName = new Intl.DateTimeFormat("en-US", {
  month: "long",
}).format(now);
const currentMonthNumber = String(now.getMonth() + 1).padStart(2, "0");

const db = {
  icon_black:
    "https://res.cloudinary.com/defwvlcup/image/upload/v1674636928/25thandstaffing/icon_black_yvmoug.png",
  icon_white: icon_white,
  hero: hero,
  seekers: seekers,
  hunters: hunters,
  user: "https://eu2.contabostorage.com/d6c5f85cb8c7411686db1028a11f1030:25thandstaffing/global/user.png",
  teams_bg: [teams_bg],
  twitter: twitter,
  arrow: arrow,
  error404: error404,
  down: down,
  checkmark: checkmark,
  star: star,
  proven: proven,
  protect: protect,
  gives: gives,
  creates: creates,
  left: left,
  right: right,
  target: target,
  idea: idea,
  contingency: contingency,
  giveSlider: giveSlider,
  giveSlider2: giveSlider2,
  giveSlider3: giveSlider3,
  giveSlider4: giveSlider4,
  world: world,
  generalImpact: generalImpact,
  kinabuti: kinabuti,
  kinabuti2: kinabuti2,
  kids: kids,
  slider1: slider1,
  help: help,
  charity: charity,
  charity2: charity2,
  avatar: avatar,

  // partners imgs
  cri2: cri2,
  veriteks: veriteks,
  tm: tm,
  chi: chi,
  cadg: cadg,
  e_transact: e_transact,
  lsef: lsef,
  bc: bc,
  charles_araujo: charles_araujo,
  gsm_systems: gsm_systems,
  leda_health: leda_health,
  mtn: mtn,
  laspark: laspark,
  mavenir: mavenir,
  airtel: airtel,
  ikejaElectric: ikejaElectric,
  scoa: scoa,
  ACCL: ACCL,
  maison: maison,
  proforce: proforce,
  sunmetal: sunmetal,

  partners: [
    cri2,
    veriteks,
    tm,
    chi,
    cadg,
    e_transact,
    lsef,
    bc,
    charles_araujo,
    gsm_systems,
    leda_health,
    mtn,
    laspark,
    mavenir,
    airtel,
    ikejaElectric,
    scoa,
  ],

  services: [service_one, service_two, service_three],

  // processes: [
  //   {
  //     id: 1,
  //     title: "Tell us your needs",
  //     description:
  //       "Our Client relations officer will consult, advice and understand all your needs.",
  //   },
  //   {
  //     id: 2,
  //     title: "Sign contract/Agreement",
  //     description:
  //       "For the initiation of the selected recruitment product, contract terms and agreement will be defined and agreed upon.",
  //   },
  //   {
  //     id: 3,
  //     title: "Deposit/Advance Payment",
  //     description:
  //       "Based on the recruitment package opted for, a defined percentage of the total recruitment cost must be paid in advance.",
  //   },
  //   {
  //     id: 4,
  //     title: "We find the best candidates",
  //     description:
  //       "Based on selected package, we will send you 1-2 vetted candidates for selection.",
  //   },
  // ],

  processes: [
    {
      id: 1,
      title: "Define Your Hiring Blueprint",
      description:
        "Choose your package and complete your talent blueprint. Define role requirements, skills and performance expectations",
    },
    {
      id: 2,
      title: "AI Interview & Analysis",
      description:
        "Our AI recruiter conducts structured, bias-aware interviews to evaluate skills, communication and problem-solving",
      linkText: "AI recruiter",
      linkHref: "https://25thairecruiter.com/",
    },
    {
      id: 3,
      title: "Intelligent Vetting & Scoring",
      description:
        "Our advanced AI analyzes interviews to provide unbiased, objective scores and insights based on predefined success metrics",
    },
    {
      id: 4,
      title: "Receive Vetted Candidates",
      description:
        "Get a shortlist of top-ranked, AI-vetted candidates with detailed interview summaries and fit scores",
    },
  ],

  verticals: [
    { id: 1, title: "Tech & Telco", path: tech },
    { id: 2, title: "Finance & banking", path: finance },
    { id: 3, title: "Education", path: education },
    { id: 4, title: "Hospitality", path: hospitality },
    { id: 5, title: "Construction", path: construction },
    { id: 6, title: "Public sector", path: pub },
    { id: 7, title: "Energy", path: energy },
    { id: 8, title: "Maritime", path: maritime },
    { id: 9, title: "Manufacturing", path: manufacturing },
  ],

  testimonies: [
    {
      id: 1,
      content:
        "Their ability to source talent across diverse markets while maintaining high-quality service has been instrumental to our success. I wholeheartedly recommend 25th and Staffing to any organization seeking a trusted partner for global staffing solutions.",
      // content: "25th and Staffing has been engaged with Tech Mahindra for providing manpower and sourcing and outsourcing resources for right profile.",
      name: "Ayan Chatterjee",
      company: "(Finance, Africa - Tech Mahindra, April 2025)",
      // company: "(Finance, Africa - Tech Mahindra, October 2022)",
      linkedin: "https://www.linkedin.com/in/ayan-chatterjee-1209349/",
      path: cri,
    },
    {
      id: 2,
      content:
        "Based on the process and evaluation provided by your team, I must say it has been an exceptional and highly professional experience. I couldn't have asked for more.",
      name: "Tarek Khoury",
      company: "(Operations Manager - Erik Kayser, August 2023)",
      linkedin: "https://www.linkedin.com/in/tarek-khoury-500159115/",
      path: cri,
    },
    {
      id: 3,
      content:
        "Emem is truly professional and understood the complex nature of the role we were recruiting for and skill required quickly. The candidates Emem and her team sourced were of a high caliber.",
      name: "Michele de Kock",
      company: "(HR Manager, Africa - Bain & Company, July 2018)",
      linkedin: "",
      path: bainCompany,
    },
    {
      id: 4,
      content:
        "25th and Staffing have been providing skilled and professional human resource services to GSMSystems since 2016 and their performance have been very satisfactory meeting all our expectations.",
      name: "Gideon Itulua",
      company: "(Director - GSM Systems Africa, July 2018)",
      linkedin: "https://www.linkedin.com/in/gideon-itulua-b64064114",
      path: gsm,
    },
    {
      id: 5,
      content:
        "The company, 25th and Staffing, is well known to our firm. They have been our preferred recruiter for several years and have over time, consistently provided our company with a pool of diverse, talented and resourceful candidates regardless of the role.",
      name: "Abimbola Balogun",
      company: "(General Manager - M & W Nuts, September 2018)",
      linkedin: "https://www.linkedin.com/in/abimbola-balogun-3646042b",
      path: mw,
    },
    {
      id: 6,
      content:
        "25th and Staffing Limited has been our recruitment consultant/vendor, from January 2017 till date and they have delivered on all our agreed services. Most importantly their approach was very professional and they paid attention to detail on all our requests.",
      name: "Niyi Toluwalope",
      company: "(CEO - eTranzact, January 2017)",
      linkedin: "https://www.linkedin.com/in/niyi-toluwalope-9219611",
      path: etranzact,
    },
    {
      id: 7,
      content:
        "25th and Staffing Limited is our recruitment vendor, from January 2018 till date. I can confirm that we have enjoyed a remarkable working relationship, and that they have delivered nothing short of excellence in the services rendered.",
      name: "Adeboye Shonekan",
      company: "(Chairman - CRI, January 2018)",
      linkedin: "",
      path: cri,
    },
  ],

  testimoniesTalent: [
    {
      id: 1,
      content:
        "Working at Leda Health has been nothing short of amazing. The work culture is top-notch. I enjoy their transparency, honesty, and people-oriented approach. 25th and Staffing has been awesome since day one. Friendly and wonderful staff. Timely in delivery too 😊.",
      name: "Elizabeth Adeyemo (Leda Health Co)",
      path: elizabeth,
    },
    {
      id: 2,
      content:
        "Thanks to 25th and Staffing, I got interviewed with Sunbird Group and it's been a career - dream come true. The support I've gotten from 25th and Staffing every step of the way is nothing short of excellent. They were fully involved in the whole interview process, and have remained the ultimate professionals. I would definitely recommend 25th and Staffing to anyone looking for a job!",
      name: "Deborah Akugue (Sunbird)",
      path: deborah,
    },
    {
      id: 3,
      content:
        "It's a pleasure to share, the last 5 months have been beautiful for me, the experience working with Leda Health is really intriguing and I do appreciate 25th and Staffing for the opportunity to connect with End.",
      name: "Chinyere Linda (Leda Health Co)",
      path: chinyere,
    },
  ],

  bespoke: [
    {
      id: 1,
      title: "Discovery",
      path: discovery,
      content:
        "Deeply understands your needs, and create a plan for execution.",
    },
    {
      id: 2,
      title: "Kick Off",
      path: kickoff,
      content:
        "Conduct extensive research, create a profile of your ideal executive and create a pool of hand picked executive talent.",
    },
    {
      id: 3,
      title: "Precise Search Process",
      path: precise,
      content:
        "We conduct back to back interviews with highly-skilled, passionate executives.",
    },
    {
      id: 4,
      title: "Final Interview Stage",
      path: final,
      content:
        "You make your final selection, and we manage all recruitment and negotiation.",
    },
    {
      id: 5,
      title: "Search Conclusion",
      path: check,
      content:
        "You hire an experienced executive under an accelerated timeline.",
    },
  ],

  leadership: [
    { id: 1, path: ememUsen, name: "Emem Usen", jd: "CEO/Co-founder" },
    {
      id: 2,
      path: atsuEmmanuel,
      name: "Emmanuel Atsu",
      jd: "Chief Technical Officer",
    },
    // {
    //   id: 3,
    //   path: jairaj,
    //   name: "Jairaj Suvarna",
    //   jd: "Independent Consultant",
    // },
    // { id: 4, path: susan, name: 'Susan Iliyan', jd: 'Business Dev. Consultant' },
  ],

  teamMember: [
    // {
    //   id: 3,
    //   path: abdulrasheedOladipo,
    //   name: "Abdulrasheed Oladipo",
    //   jd: "Product Accountant",
    // },
    // {
    //   id: 4,
    //   path: avatar,
    //   name: "Eseosa Igunbor",
    //   jd: "Project Coordinator",
    // },
    {
      id: 5,
      path: gabrielIkponmwosa,
      name: "Gabriel Ikponmwosa",
      jd: "B2B Sales Executive",
    },
    // {
    //   id: 6,
    //   path: avatar,
    //   name: "Funmilayo Akintewe",
    //   jd: "HR Generalist",
    // },
    // {

    {
      id: 9,
      path: ebenezerNdukwe,
      name: "Ebenezer Ndukwe",
      jd: "Frontend Engineer",
    },
    {
      id: 10,
      path: tobiAkintelure,
      name: "Tobiloba Akintelure",
      jd: "Backend Engineer",
    },
    {
      id: 11,
      path: khalidMisbaudeen,
      name: "Khalid Misbaudeen",
      jd: "Workflow Automation Engr & Internal Automation Specialist",
    },
    {
      id: 12,
      path: christianMonte,
      name: "Christian Monte",
      jd: "UI/UX Designer & Social Media Specialist",
    },
    // { id: 13, path: toheebRaheem, name: "Toheeb Raheem", jd: "Scrum Master" },
    // { id: 13, path: avatar, name: "Ibrahim Adeleye", jd: "Product Tester" },
    {
      id: 14,
      path: danielIleso,
      name: "Daniel Ileso",
      jd: "Graduate Content Associate",
    },
    {
      id: 8,
      path: oyatogunEniola,
      name: "Eniola Oyatogun ",
      jd: "Talent Acquisition Specialist",
    },
    // {
    //   id: 13,
    //   path: chiamakaEze,
    //   name: "Chiamaka Eze",
    //   jd: "Talent Acquisition Specialist",
    // },
    // {
    //   id: 15,
    //   path: sandraOghogho,
    //   name: "Sandra Oghogho",
    //   jd: "Product Accountant",
    // },
    // {
    //   id: 8,
    //   path: sanniAdesanya,
    //   name: "Sanni Adesanya",
    //   jd: "HR Generalist",
    // },
    { id: 15, path: anabelInah, name: "Anabel Inah", jd: "Office Support" },
  ],
  teamMember2: [
    { id: 1, path: avatar, name: "Ibrahim Adeleye", jd: "Product Tester" },
    {
      id: 2,
      path: avatar,
      name: "Daniel Ileso",
      jd: "Graduate Content Associate",
    },
    { id: 3, path: avatar, name: "Anabel Inah", jd: "Office Support" },
  ],

  faq: [
    {
      id: 1,
      title: "Internal Quality Check: We Practice What We Preach:",
      content:
        "We're Not Just Timekeepers; We're Time Masters. We adhere to timelines with the precision of a Swiss watch.",
    },
    {
      id: 2,
      title: "Reports That Speak Volumes:",
      content:
        "Our reports are like Sherlock Holmes novels - simple, detailed, and revealing personal and professional attributes, complete with the plot twists of pros and cons.",
    },
    {
      id: 3,
      title: "Proactive Communication is Our Superpower:",
      content:
        "We don't wait for the phone to ring; we make it sing.Proactive updates throughout the recruitment process are our way of staying ahead of the curve.",
    },
    {
      id: 4,
      title: "Tailored Services, Not One Size Fits All:",
      content:
        "No cookie-cutter solutions here. We tailor our services like bespoke suits, ensuring a perfect fit for each client's unique needs.",
    },
  ],

  cards: [
    {
      id: 1,
      text: "Faster Integration",
      subtitle:
        "Structured onboarding and regular check-ins ensure your executive hits the ground running and delivers impact from day one.",
    },
    {
      id: 2,
      text: "Better Retention",
      subtitle:
        "Proactive monitoring and support significantly reduce early turnover while improving long-term engagement.",
    },
    {
      id: 3,
      text: "Protected Investment",
      subtitle:
        "Avoid the high cost of early exits or slow ramp-up with our comprehensive success monitoring approach.",
    },
  ],
  executivePackage: {
    title: "Executive Package",
    month: "3 Months",
    price: "₦750,000 – ₦1.2M",
    list: [
      {
        id: 1,
        icon: checkmark,
        text: "*CEO-Led Onboarding Alignment",
      },
      {
        id: 2,
        icon: checkmark,
        text: "2 Performance Check-In Sessions",
      },
      {
        id: 3,
        icon: checkmark,
        text: "Culture & Team Integration Strategy",
      },
      {
        id: 4,
        icon: checkmark,
        text: "Employer–Executive Feedback Loops (Month 1)",
      },
      {
        id: 5,
        icon: checkmark,
        text: "Leadership Gap Review & Success Roadmap",
      },
      {
        id: 6,
        icon: checkmark,
        text: "Final Progress Report to Leadership",
      },
    ],
    note: "*Depends on the role.",
  },
  vipPackage: {
    title: "VIP Package",
    month: "6 Months",
    price: "₦1.5M – ₦3M",
    list: [
      {
        id: 1,
        icon: checkmark,
        text: "CEO-Led Onboarding Alignment",
      },
      {
        id: 2,
        icon: checkmark,
        text: "Weekly Check-ins (Month 1), then Biweekly",
      },
      {
        id: 3,
        icon: checkmark,
        text: "Culture & Team Integration Strategy",
      },
      {
        id: 4,
        icon: checkmark,
        text: "Monthly Employer–Executive Feedback Loops",
      },
      {
        id: 5,
        icon: checkmark,
        text: "Leadership Gap Review & Success Roadmap with tailored development plan",
      },
      {
        id: 6,
        icon: checkmark,
        text: "Ongoing Progress Reports to Leadership",
      },
      {
        id: 7,
        icon: checkmark,
        text: "Retention Risk Monitoring",
      },
      {
        id: 8,
        icon: checkmark,
        text: "Dedicated Priority Liaison",
      },
      {
        id: 9,
        icon: checkmark,
        text: "Exit & Transition Coaching (if required)",
      },
    ],
  },
  whyUs: {
    list: [
      {
        id: 1,
        icon: proven,
        text: "Proven with executives we've placed",
        subtitle:
          "Our clients have found it reduces early turnover and improves leadership impact.",
      },
      {
        id: 2,
        icon: protect,
        text: "Protects your hiring investment",
        subtitle:
          "Avoids the high cost of early exits or slow ramp-up during a recruitment process.",
      },
      {
        id: 3,
        icon: gives,
        text: "Gives employers real-time insights",
        subtitle:
          "Regular reporting ensures you know exactly how your new leader is performing and integrating.",
      },
      {
        id: 4,
        icon: creates,
        text: "Creates confidence at the top level",
        subtitle:
          "With CEO-led involvement, both employer and executive benefit from direct, high-touch guidance.",
      },
    ],
    title: "Important Notes",
    note: [
      {
        id: 1,
        icon: checkmark,
        text: "These packages are separate from our Recruitment Guarantee.",
      },
      {
        id: 2,
        icon: checkmark,
        text: "Our recruitment guarantee covers replacement. Post-Placement covers success, retention, and performance.",
      },
      {
        id: 3,
        icon: checkmark,
        text: "Executive package is available to all clients.",
      },
      {
        id: 4,
        icon: checkmark,
        text: "VIP is invitation only, reserved for organizations where leadership continuity is mission-critical.",
      },
    ],
  },
  bullets: [
    "Motherless babies & orphans support",
    "Widows empowerment programs",
    "Education & skills development",
    "Community empowerment projects",
    "Your donation is used where help is needed most",
  ],
  bullets2: [
    "Providing education, mentorship, and life skills programs for underprivileged youth",
    "Supporting community development projects that uplift vulnerable families",
    "Support a targeted cause that aligns with your passion",
  ],

  legal: {
    companyName: "25th and Staffing",
    currentYear: new Date().getFullYear(),
    privacyVersion: "1.0",
    // privacyLastUpdated: "February 2026",
    privacyLastUpdated: `${currentMonthName} ${currentYear}`,
    termsVersion: "1.0",
    // termsLastUpdated: "February 2026",
    termsLastUpdated: `${currentMonthName} ${currentYear}`,
    // cookiePolicyVersion: "2026.02",
    cookiePolicyVersion: `${currentYear}.${currentMonthNumber}`,
  },
};

export default db;
